import { render, staticRenderFns } from "./rms-objects-uploads.vue?vue&type=template&id=338821da&scoped=true"
import script from "./rms-objects-uploads.vue?vue&type=script&lang=js"
export * from "./rms-objects-uploads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338821da",
  null
  
)

export default component.exports